// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"85bd0526","703":"0d742b94","787":"6734b432"}[chunkId] + ".chunk.js";
};